module.exports = __webpack_public_path__ + "img/rocket_internet.69914b41.png";